import React from 'react';
import { motion } from 'framer-motion';
import { Utensils, Armchair, Sparkles } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    icon: Utensils,
    title: '3 Comidas Simples',
    description: 'Comida normal, barata y repetible. Sin contar calorías ni pasar hambre.',
    color: 'bg-[#E07856]'
  }, {
    icon: Armchair,
    title: '3 Movimientos de Silla',
    description: 'Solo 5–6 minutos al día. Suave, seguro y sin impacto para tus articulaciones.',
    color: 'bg-[#8BA888]'
  }, {
    icon: Sparkles,
    title: '3 Hábitos Anti-hinchazón',
    description: 'Pequeños ajustes diarios que cambian radicalmente cómo te sientes al final del día.',
    color: 'bg-[#5B9BD5]'
  }];
  return <section className="py-24 bg-[#FAF7F2]" data-id="element-217">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-219">
          <span className="text-[#8BA888] font-bold text-xl tracking-wide uppercase" data-id="element-220">
            La Solución
          </span>
          <h2 className="mt-2 text-4xl sm:text-5xl font-bold text-[#2D3748]" data-id="element-221">
            14 días con el{' '}
            <span className="text-[#E07856]" data-id="element-222">Protocolo 3-3-3</span>
          </h2>
          <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-223">
            Una guía directa, en español, hecha para mujeres que quieren
            resultados que se sientan... sin complicarse la vida.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-224">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border-t-4 border-[#E07856]" data-id="element-225">
              <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mb-6 text-white`} data-id="element-226">
                <step.icon className="w-8 h-8" data-id="element-227" />
              </div>
              <h3 className="text-2xl font-bold text-[#2D3748] mb-4" data-id="element-228">
                {step.title}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-229">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}